import { render, staticRenderFns } from "./documentRequestDetailIndividual.vue?vue&type=template&id=6c06b8c8&scoped=true&"
import script from "./documentRequestDetailIndividual.vue?vue&type=script&lang=js&"
export * from "./documentRequestDetailIndividual.vue?vue&type=script&lang=js&"
import style0 from "./documentRequestDetailIndividual.vue?vue&type=style&index=0&id=6c06b8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06b8c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow,VSelect,VTextarea})
